

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Box, Typography, CircularProgress } from "@mui/material";
import axios from "axios";

export default function StaticTermsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchPage = async () => {
      setLoading(true);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}terms/slug/${slug}`
        );

        if (response.data?.status && response.data?.data) {
          setPage(response.data.data);
          setNotFound(false);
        } else {
          setNotFound(true);
          setPage(null);
        }
      } catch (err) {

        setNotFound(true);
        setPage(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (notFound) {
    return (
      <Container sx={{ py: 8, textAlign: "center" }}>
        <Typography variant="h4" fontWeight={600}>
          Page Not Found
        </Typography>
        <Typography color="text.secondary">
          The page you’re looking for doesn’t exist or has been removed.
        </Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h5" fontWeight={600} textAlign="center" mb={3}>
        {page?.title || "Untitled Page"}
      </Typography>

      <Box
        sx={{ "& p": { mb: 2 } }}
        dangerouslySetInnerHTML={{
          __html: page?.content || "<p>No content available.</p>",
        }}
      />
    </Container>
  );
}
